import Controller from '@ember/controller';
import { BUYER_SIGNUP_STEPS } from 'sh-www/constants/buyer-signup-step';

const CLASS_NAME = 'GLM-brand-signup-pending-approval';

class BrandSignupPendingApprovalController extends Controller {
  get className() {
    return CLASS_NAME;
  }

  get isCompanyJoinRequest() {
    return this.model.step === BUYER_SIGNUP_STEPS.COMPANY_PENDING_APPROVAL_STEP;
  }
}

export default BrandSignupPendingApprovalController;
